import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const CloseIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 65 65" {...props}>
      <path
        fill={fill}
        d="M72.9071887,30.9552137 L50.2765343,30.9045471 L50.327201,8.27389109 C50.3365343,4.04989309 46.8885362,0.58722806 42.6645385,0.57789473 L38.6525406,0.5685614 C34.4298763,0.55922807 30.9658782,4.00722644 30.9565448,8.23122444 L30.9058782,30.8618804 L8.27389053,30.8112138 C4.05122617,30.8005471 0.58856139,34.2485455 0.57789473,38.4725435 L0.5685614,42.4845416 C0.55922807,46.7085396 4.00722619,50.172538 8.23122389,50.1818713 L30.8618782,50.2325379 L30.8112116,72.8631939 C30.8018783,77.0871919 34.2498764,80.5498569 38.4738741,80.5591903 L42.4872052,80.5685236 C46.7098696,80.5778569 50.1725344,77.1298585 50.1818677,72.9058605 L50.2325343,50.2765379 L72.864522,50.3258712 C77.0871864,50.3365379 80.5498512,46.8885395 80.5605178,42.6645415 L80.5685178,38.6512101 C80.5791845,34.4272121 77.1311864,30.964547 72.9071887,30.9552137"
        transform="rotate(45 46.226 26.912)"
      />
    </Icon>
  );
};

CloseIcon.propTypes = {
  fill: PropTypes.string,
};

export default CloseIcon;
